// A deploy during the event replaces the site's code files. A page that was already open then asks
// for a code file that no longer exists (Vite fires `vite:preloadError`), and the screen it was
// opening fails. Reloading once loads the new version.

/** Shared with the inline handler in index.html and score/index.html, so the two never loop. */
const KEY = 'spark:reloadedForUpdate'
/** A second failure this soon after a reload is a real problem, not an old page: show it instead of looping. */
const GUARD_MS = 60_000

export function reloadOnStaleChunks(): void {
  window.addEventListener('vite:preloadError', (event) => {
    // Already handled (the page's inline handler reloads too).
    if (event.defaultPrevented) return
    // Offline, the file is not gone, the network is; a reload would lose the page.
    if (!navigator.onLine) return
    try {
      const last = Number(sessionStorage.getItem(KEY) ?? 0)
      if (Date.now() - last < GUARD_MS) return
      sessionStorage.setItem(KEY, String(Date.now()))
    } catch {
      // Without storage there is no loop guard, so let the error show.
      return
    }
    event.preventDefault()
    window.location.reload()
  })
}
